import { c as _c } from "react/compiler-runtime";
import { ArrowDownIcon, Button, Menu, Tooltip } from "@flat-ui";
import { Box, useTheme } from "@mui-wrapper";
import { useState } from "react";
import { getRippleColorWithOpacity } from "@utils/ripple-color-utils";
/** Renders text button having a menu opened as a dropdown */
export function FaroTextMenuButton(t0) {
  const $ = _c(52);
  const {
    buttonTitle,
    tooltipText,
    isDisabled,
    children,
    buttonSx,
    isMenuWidthEqualToButton: t1,
    shouldShowEndIcon: t2,
    rippleColor,
    startIcon,
    menuPosition
  } = t0;
  const isMenuWidthEqualToButton = t1 === undefined ? false : t1;
  const shouldShowEndIcon = t2 === undefined ? true : t2;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  let t3;
  if ($[0] !== rippleColor || $[1] !== theme) {
    t3 = getRippleColorWithOpacity(rippleColor, theme);
    $[0] = rippleColor;
    $[1] = theme;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const rippleColorWithOpacity = t3;
  const t4 = !isMenuOpen ? tooltipText : "";
  const t5 = isMenuOpen ? "faro-text-menu" : undefined;
  const t6 = !!isMenuOpen;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => setAnchorEl(event.currentTarget);
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== shouldShowEndIcon) {
    t8 = shouldShowEndIcon ? <ArrowDownIcon /> : undefined;
    $[4] = shouldShowEndIcon;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = rippleColorWithOpacity ?? "0";
  const t10 = rippleColorWithOpacity ?? "transparent";
  let t11;
  if ($[6] !== t10) {
    t11 = {
      backgroundColor: t10
    };
    $[6] = t10;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const t12 = rippleColorWithOpacity ?? "transparent";
  let t13;
  if ($[8] !== t12) {
    t13 = {
      backgroundColor: t12
    };
    $[8] = t12;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== rippleColor) {
    t14 = rippleColor && {
      "&& .MuiTouchRipple-child": {
        backgroundColor: `${rippleColor}3F`
      }
    };
    $[10] = rippleColor;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== buttonSx || $[13] !== isMenuOpen) {
    t15 = buttonSx?.(isMenuOpen);
    $[12] = buttonSx;
    $[13] = isMenuOpen;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== t11 || $[16] !== t13 || $[17] !== t14 || $[18] !== t15 || $[19] !== t9) {
    t16 = {
      fontSize: "12px",
      textTransform: "none",
      color: "primary.main",
      borderRadius: t9,
      "&:hover": t11,
      "&:focus-visible": t13,
      ...t14,
      ...t15
    };
    $[15] = t11;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t9;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== buttonTitle || $[22] !== isDisabled || $[23] !== startIcon || $[24] !== t16 || $[25] !== t5 || $[26] !== t6 || $[27] !== t8) {
    t17 = <Button disabled={isDisabled} aria-controls={t5} aria-haspopup="true" aria-expanded={t6} variant="ghost" disableElevation={true} disableRipple={true} draggable={false} onClick={t7} endIcon={t8} icon={startIcon} sx={t16}>{buttonTitle}</Button>;
    $[21] = buttonTitle;
    $[22] = isDisabled;
    $[23] = startIcon;
    $[24] = t16;
    $[25] = t5;
    $[26] = t6;
    $[27] = t8;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== menuPosition?.anchorOrigin) {
    t18 = menuPosition?.anchorOrigin ?? {
      vertical: "bottom",
      horizontal: "right"
    };
    $[29] = menuPosition?.anchorOrigin;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== menuPosition?.transformOrigin) {
    t19 = menuPosition?.transformOrigin ?? {
      vertical: "top",
      horizontal: "right"
    };
    $[31] = menuPosition?.transformOrigin;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => setAnchorEl(null);
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  const t21 = isMenuWidthEqualToButton ? anchorEl && anchorEl.offsetWidth : "225px";
  let t22;
  if ($[34] !== t21) {
    t22 = {
      list: {
        sx: {
          width: t21
        }
      }
    };
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => setAnchorEl(null);
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== children) {
    t24 = <Box component="div" onClick={t23}>{children}</Box>;
    $[37] = children;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== anchorEl || $[40] !== isMenuOpen || $[41] !== t18 || $[42] !== t19 || $[43] !== t22 || $[44] !== t24) {
    t25 = <Menu id="faro-text-menu" anchorOrigin={t18} transformOrigin={t19} anchorEl={anchorEl} open={isMenuOpen} onClose={t20} minWidth="unset" slotProps={t22}>{t24}</Menu>;
    $[39] = anchorEl;
    $[40] = isMenuOpen;
    $[41] = t18;
    $[42] = t19;
    $[43] = t22;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t17 || $[47] !== t25) {
    t26 = <>{t17}{t25}</>;
    $[46] = t17;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t26 || $[50] !== t4) {
    t27 = <Tooltip component="div" title={t4}>{t26}</Tooltip>;
    $[49] = t26;
    $[50] = t4;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  return t27;
}